import { api } from ":mods";
import { CONST, model } from "..";
import { AShowcase } from "../../model";

export async function detailsPut(showcase: number | string, data: model.PutShowcase) {
  return api
    .putAuth(CONST.ENDPOINTS.admin.detail_showcase(showcase), data)
    .then((res) => res.data.data.show_cases as AShowcase);
}
